module.exports = "<div class=\"loading-wrapper\">\r\n    <div class=\"loading\"></div>\r\n  </div>"